<template>
  <div id="chart-line" v-loading="chartLoading">
    <el-row>
      <el-col :span="12">
        <div style="width:100%; text-align:center;">
          <div id="plotly" ref="plotly" style="
          flex:1;
          width:500px;
          height:500px;
      margin: 0 auto;
      " />
        </div>
      </el-col>

      <el-col :span="12">
        <el-select @change="initOrbitAnalyze" v-model="axis1" placeholder="Select" class="w-100">
          <el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <ChartTimeMini :rawData="rawData" :samplingRate="samplingRate" v-model="visibleRange"></ChartTimeMini>

        <el-select @change="initOrbitAnalyze" v-model="axis2" placeholder="Select" class="w-100">
          <el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <ChartTimeMini :rawData="rawData2" :samplingRate="samplingRate" v-model="visibleRange"></ChartTimeMini>
      </el-col>
    </el-row>

    <el-row class="toolbox">
      <el-col>
        <el-form ref="form" inline label-position="top" label-width="100px" size="small">
          <el-form-item :label="$t('measurement.window')">
            <el-select v-model="window">
              <el-option v-for="window in windows" :key="window" :label="window" :value="window" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('measurement.referenceFrequency')">
            <el-input @blur="initOrbitAnalyze" @keyup.enter.native="initOrbitAnalyze" v-model="localReferenceFrequency" :value="referenceFrequency">
            </el-input>
            <span v-if="localReferenceFrequency==0" style="color:red">{{$t("common.rotationspeed")}}</span>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Plotly from "./Plotly";
import cachios from "cachios";
import ChartTimeMini from "./Chart_TimeMini";
export default {
  name: "oribtanalyze-chart",
  events: [],
  props: {
    measurement: {
      type: Object,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
    referenceFrequency: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ChartTimeMini,
  },
  data() {
    return {
      axis1: "",
      axis2: "",
      chartLoading: true,
      series: [
        {
          x: [],
          y: [],
        },
      ],
      selectList: [],
      rawData: [],
      rawData2: [],
      localReferenceFrequency: 0,
      visibleRange: [],
      window: "rectangular",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],

    };
  },
  mounted() {
    this.init();
  },
  methods: {
    axisChanged() { },

    initOrbitAnalyze() {
      console.log(this.localReferenceFrequency)
      this.rawData = this.measurement.data[this.axis1];
      this.rawData2 = this.measurement.data[this.axis2];
      this.chartLoading = true;
      cachios
        .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/orbit-analyze`, {
          window: this.window,
          dcOffset: true,
          referenceFrequency: parseFloat(this.localReferenceFrequency),
          signal: this.rawData.slice(
            this.visibleRange[0],
            this.visibleRange[1]
          ),
          signal2: this.rawData2.slice(
            this.visibleRange[0],
            this.visibleRange[1]
          ),
          samplingRate: this.samplingRate,
        })
        .then(async (response) => {

          var orbit = {

            r: response.data.r,
            theta: response.data.phase.map(y => (y * 180 / Math.PI)),
            thetaunit: 'degrees',
            mode: 'lines',
            name: 'phase',
            marker: {
              color: 'rgb(191 191 191)',
            },
            type: 'scatterpolar',
          };
          var mean = {

            r: response.data.r_mean,
            theta: response.data.phase_mean.map(y => (y * 180 / Math.PI)),
            thetaunit: 'degrees',
            mode: 'lines',
            name: 'mean',
            marker: {
              color: '#00519D',
            },
            type: 'scatterpolar',
          };
          var data = [orbit, mean];

          var layout = {
            width:500,
            height: 500,
            margin: {
              l: 20,
              r: 20,
              b: 20,
              t: 20,
            },
            displaylogo: false,
            polar: {

              radialaxis: {
                tickfont: {
                  size: 12
                },
                // range: [-2, 1.5],
                //tickangle: 45
              },

              angularaxis: {
                tickfont: {
                  size: 12
                },
                dtick: 30,
                rotation: 90,
                direction: "clockwise"
              }
            },
            title: '',
          };
          let pl = await Plotly.newPlot(this.$refs.plotly, data, layout, {
            displayModeBar: true,
            displaylogo: false,
            doubleClick: "reset",
            responsive: true,
          });
        })
        .finally(() => {
          this.chartLoading = false;
        });
    },
    init() {
      if (!this.measurement) {
        return;
      }
      this.selectList =
        this.measurement.measurementData.length > 0
          ? this.measurement.measurementData
            .map((x) => x.key)
            .sort()
            .map((x) => {
              return { value: x, label: this.$t(`measurement.${x}`) };
            })
          : [];

      this.axis1 = this.selectList[0].value;
      this.axis2 = this.selectList[1].value;
      if (this.measurement.point && this.measurement.point.referenceFrequency) {
        this.localReferenceFrequency =
          this.measurement.point.referenceFrequency;
      }
      this.initOrbitAnalyze();
    },
  },
  watch: {
    visibleRange: function (range) {
      this.initOrbitAnalyze();
    },
    measurement: function () {
      this.initOrbitAnalyze();
    },
    window: function () {
      this.initOrbitAnalyze();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}

*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
